import * as React from 'react';
import * as classNames from 'classnames';
import * as CreDtos from "../../../CRE.dtos";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Spinner } from '../../Controls/Spinner';
import * as PublicationActionCreators from "../../../actions/publications.actions";

export interface IPublicationsProps {
    publications: CreDtos.Publication[];
    publicationTypes: CreDtos.PublicationType[];
    publicationTypeId: number;
    showResources: any[];
    showResource: number;
    isLoading: boolean;
    load: Function;
    edit: Function;
    add: Function;
    search: string;
    showDisabled: boolean;
    filter: Function;
}

interface IPublicationState {
    search: string
}

class Publications extends React.Component<IPublicationsProps, IPublicationState> {
    constructor(props: IPublicationsProps) {
        super(props);
        this.props.load();
        // push to redux state
        this.state = {
            search: this.props.search
        }
        this.onSearch = this.onSearch.bind(this);
        this.onSearchChanged = this.onSearchChanged.bind(this);
        this.onShowDisabledChanged = this.onShowDisabledChanged.bind(this);
        this.onPublicationTypeChanged = this.onPublicationTypeChanged.bind(this);
        this.onEdit = this.onEdit.bind(this);
    }

    onSearchChanged(e) {
        this.setState({ search: e });
    }

    onSearch() {
        this.props.filter(this.state.search, this.props.showDisabled, this.props.publicationTypeId, this.props.showResource);
    }

    onShowDisabledChanged(e) {
        this.props.filter(this.props.search, !this.props.showDisabled, this.props.publicationTypeId, this.props.showResource);
    }

    onEdit(item: CreDtos.Publication) {
        this.props.edit(item);
    }

    onPublicationTypeChanged(id: number) {
        this.props.filter(this.props.search, this.props.showDisabled, id, this.props.showResource);
    }

    onShowResourceChanged(id: number) {
        this.props.filter(this.props.search, this.props.showDisabled, this.props.publicationTypeId, id);
    }

    render() {
        let content;

        if (this.props.isLoading) {
            content = (
                <Spinner isOpen={this.props.isLoading} />
            );
        } else {
            let items;
            if (this.props.publications.length > 0) {
                items = this.props.publications.map((item, index) => {
                    return (
                        <div className="row pt-2 pb-2" key={"research" + item.id}>
                            <div className={classNames("col col-6 col-lg-7", { "row-disabled-text": !item.enabled })}>{item.title}</div>
                            
                            <div className="col col-2 col-lg-2">
                                <span>{item.year}</span>
                            </div>
                            <div className="col col-1 col-lg-1">
                                <span>{item.sortOrder}</span>
                            </div>
                            <div className="col col-1 col-lg-1">
                                <div className="text-right mr-2" onClick={() => this.onEdit(item)}>
                                    <a><span className="fa fa-edit fa-lg"></span></a>
                                </div>
                            </div>
                        </div>
                    )
                })
            } else {
                items = (
                    <div className="alert alert-info text-center" role="alert">
                        No records found
                    </div>
                );
            }

            let search = (
                <div className="search input-group mb-2">
                    <input type="search" className="form-control lightgrey-bg"
                        placeholder="Search..."
                        defaultValue={this.state.search}
                        onChange={(e) => this.onSearchChanged(e.target.value)}
                        onBlur={() => this.onSearch()}
                    />
                    <button type="button" id="searchBtn" className="input-group-addon btn btn-white" onClick={() => this.onSearch()}>
                        <span className="fa fa-search"></span>
                    </button>
                </div>
            );

            let showDisabled = (
                <div className="search input-group mb-2">
                    <label>
                        <input type="checkbox" checked={this.props.showDisabled} onChange={e => this.onShowDisabledChanged(e)} /> Show disabled
                    </label>
                </div>
            )


            let publicationTypes = (
                <div className="input-group">
                    <fieldset className="form-group">
                        <div className="form-check">
                            <label className="form-check-label">
                                <input type="radio" className="form-check-input" name="optionsPublicationType" id="publicationTypeName0" onClick={() => this.onPublicationTypeChanged(0)} checked={this.props.publicationTypeId == 0} />
                                &nbsp;&nbsp;All
                            </label>
                        </div>
                        {this.props.publicationTypes.map((item) => (
                            <div className="form-check" key={"publicationTypeName" + item.id}>
                                <label className="form-check-label">
                                    <input type="radio" className="form-check-input" name="optionsPublicationType" id={"publicationTypeName" + item.id} onClick={() => this.onPublicationTypeChanged(item.id)} checked={this.props.publicationTypeId == item.id} />
                                    &nbsp;&nbsp;{item.publicationTypeName}
                                </label>
                            </div>
                        ))}

                    </fieldset>
                </div>
            );

            let showResources = (
                <div className="input-group">
                    <fieldset className="form-group">
                        {this.props.showResources.map((item) => (
                            <div className="form-check" key={"showResource" + item.id}>
                                <label className="form-check-label">
                                    <input type="radio" className="form-check-input" name="optionsShowResource" id={"showResourceName" + item.id} onClick={() => this.onShowResourceChanged(item.id)} checked={this.props.showResource == item.id} />
                                    &nbsp;&nbsp;{item.name}
                                </label>
                            </div>
                        ))}

                    </fieldset>
                </div>
            );

            content = (
                <div className="row fixed-scrolling-side">
                    <div className="col-12 col-lg-3 pl-md-0 mb-3 discussion-board sidebar">
                        <div className="sidebar-actions">
                            <div className="row">
                                <div className="col-6">
                                    {search}
                                </div>
                                <div className="col-6">
                                    <button type="button" className="btn btn-default btn-block" onClick={() => this.props.add()}>Add Publication</button>
                                </div>
                            </div>
                            <hr />
                        </div>
                        <div className="sidebar-actions-lg">
                            {search}
                            <h6><small>Type</small></h6>
                            {publicationTypes}
                            <h6><small>Is Resource</small></h6>
                            {showResources }
                            {showDisabled}
                            <hr />
                            <button type="button" className="btn btn-default btn-block" onClick={() => this.props.add()}>Add Publication</button>
                        </div>
                    </div>
                    <div className="col-12 col-lg-9">
                        <div className="discussion-board-resource">
                            <div className="row hide-xs hide-md">
                                <div className="col-6 col-lg-7">
                                    <strong>TITLE</strong>
                                </div>
                                <div className="col-2 col-lg-2">
                                    <strong>YEAR</strong>
                                </div>
                                <div className="col-1 col-lg-1">
                                    <strong>SORT</strong>
                                </div>
                                <div className="col-1 col-lg-1">
                                </div>
                            </div>
                            {items}
                        </div>
                    </div>
                </div>

            );
        }


        return (
            <div>
                {content}
            </div>
        );
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        isLoading: state.publications.isLoading,
        publications: state.publications.filteredPublications,
        publicationTypes: state.publications.publicationTypes,
        publicationTypeId: state.publications.publicationTypeId,
        showResources: state.publications.showResources,
        showResource: state.publications.showResource,
        search: state.publications.search,
        showDisabled: state.publications.showDisabled
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            load: PublicationActionCreators.publicationsRequest,
            filter: PublicationActionCreators.publicationsFilter,
            edit: PublicationActionCreators.publicationEdit,
            add: PublicationActionCreators.publicationAdd
        },
        dispatch
    );
};


const PublicationsContainer = connect(mapStateToProps, mapDispatchToProps)(
    Publications
);

export default PublicationsContainer;


// WEBPACK FOOTER //
// ./src/components/Administration/Publications/Publications.tsx